import { AdminDesignation } from "./admindesignation.model";
import { Department } from "./department.model";
import { Role } from "./role.model";
import { ServiceDTO } from "./service.model";

export class CreateUserModel {
	id:number;
	service: Number;
	active:Number;
	block: string;
	floorNumber: string;
	roomNumber: string;
	mobileNumber: string;
	emailAddress: string;
	firstName: string;
	lastName: string;
	location: number;
	roleId: number;
	reportingTo: number;
	createdby: string;
	dOB: Date;
	designation: string;
	status: number;
	fullName: string;
	priviledge: number;
	deparment: number;
	typeOfUser: number;
	permissionType: number;
	username: string;
	gender: string;
	digiLockerId: number;
	listOfBranch: number[];
	userId: number;
	password: string;
	housingType:any;
	rollAccess: number;
	roleMenuId: number;
	designationArrayList: Array<AdminDesignation>;

	designationList: AdminDesignation[];
	roles: Role[];
	departments: Department[];
	services: any[];
}